import { FC } from 'react';

export const Google = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.6 12.227c0-.709-.064-1.39-.182-2.045H12v3.873h5.382a4.61 4.61 0 01-2.01 3.009v2.518h3.246c1.891-1.746 2.982-4.31 2.982-7.355z"
      fill="#4285F4"
    />
    <path
      d="M12 22c2.7 0 4.964-.89 6.618-2.418l-3.245-2.518c-.891.6-2.028.963-3.373.963-2.6 0-4.81-1.754-5.6-4.118H3.073v2.582C4.718 19.755 8.09 22 12 22z"
      fill="#34A853"
    />
    <path
      d="M6.4 13.9c-.2-.6-.318-1.236-.318-1.9 0-.664.118-1.3.318-1.9V7.518H3.073A9.876 9.876 0 002 12c0 1.618.39 3.136 1.073 4.482l2.59-2.018.737-.564z"
      fill="#FBBC05"
    />
    <path
      d="M12 5.982c1.473 0 2.782.509 3.827 1.49l2.864-2.863C16.955 2.991 14.7 2 12 2 8.09 2 4.718 4.245 3.073 7.518L6.4 10.1c.79-2.364 3-4.118 5.6-4.118z"
      fill="#EA4335"
    />
  </svg>
);

export const Binance = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.25 12.04l-2.215 2.215-2.215-2.215 2.215-2.216 2.215 2.216zm-7.804-.05l-2.216 2.216-2.215-2.216 2.215-2.215 2.216 2.215zm-9.98 2.185L6.68 11.96 4.465 9.745 2.25 11.96l2.215 2.215zm11.695-3.794l2.215-2.215L12.211 2 6.044 8.166 8.26 10.38l3.95-3.95 3.951 3.95zM6.124 15.834l2.215-2.215 3.95 3.95 3.951-3.95 2.215 2.216L12.29 22l-6.166-6.166z"
      fill="#F3BA2F"
    />
  </svg>
);

export const Mail = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19 5H5C3.35 5 2 6.35 2 8v8c0 1.65 1.35 3 3 3h14c1.65 0 3-1.35 3-3V8c0-1.65-1.35-3-3-3zm-.86 2c.72 0 .92.57.97.75.04.18.15.78-.48 1.13l-6.14 2.86c-.3.17-.67.17-.97 0L5.37 8.87c-.63-.35-.53-.95-.48-1.13.05-.18.25-.75.97-.75h12.28V7zM19 17H5c-.55 0-1-.45-1-1v-5.65c.13.1.26.19.4.27l6.14 2.86c.46.25.96.38 1.46.38s1-.13 1.46-.38l6.14-2.86c.14-.08.28-.17.4-.27V16c0 .55-.45 1-1 1z" />
  </svg>
);

export const SoundMuted = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 7.413L7.42 10H4v4h3.42L10 16.587V7.413zm.29-3.123a1 1 0 011.09-.21A1 1 0 0112 5v14a1 1 0 01-.62.92.84.84 0 01-.38.08 1 1 0 01-.71-.29L6.59 16H4a2 2 0 01-2-2v-4a2 2 0 012-2h2.59l3.7-3.71z"
    />
    <path d="M16 15.5a1 1 0 01-.71-1.71l5-5a1.003 1.003 0 111.42 1.42l-5 5a1 1 0 01-.71.29z" />
    <path d="M21 15.5a1 1 0 01-.71-.29l-5-5a1.005 1.005 0 011.42-1.42l5 5a1.002 1.002 0 01-.326 1.636A1 1 0 0121 15.5z" />
  </svg>
);

export const SoundPlaying = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18.36 19.36a1 1 0 01-.7-.29 1 1 0 010-1.41 8 8 0 000-11.32 1 1 0 011.41-1.41 10 10 0 010 14.14 1 1 0 01-.71.29z" />
    <path d="M15.54 16.54a1 1 0 01-.71-.3 1 1 0 010-1.41 4 4 0 000-5.66 1 1 0 011.41-1.41 6 6 0 010 8.48 1 1 0 01-.7.3z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 7.413L7.42 10H4v4h3.42L10 16.587V7.413zm.29-3.123a1 1 0 011.09-.21A1 1 0 0112 5v14a1 1 0 01-.62.92.84.84 0 01-.38.08 1 1 0 01-.71-.29L6.59 16H4a2 2 0 01-2-2v-4a2 2 0 012-2h2.59l3.7-3.71z"
    />
  </svg>
);

export const BackArrow: FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M18.98 11H7.41l2.95-2.95a.996.996 0 10-1.41-1.41L4.29 11.3a.996.996 0 000 1.41l4.66 4.66c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-2.95-2.95h11.57c.55 0 1-.45 1-1s-.45-1-1-1l-.01-.01z" />
  </svg>
);

export const RightArrow = () => <BackArrow className="-scale-x-100" />;

export const NextArrow = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={25}
      height={24}
    >
      <path d="M24.65 0h-24v24h24V0z" fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <path d="M20.34 11.29l-4.66-4.66a.996.996 0 10-1.41 1.41l2.95 2.95H5.65c-.55 0-1 .45-1 1s.45 1 1 1h11.57l-2.95 2.95a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l4.66-4.66a.996.996 0 000-1.41l-.01.01z" />
    </g>
  </svg>
);

export const Wallet = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.78 20.967H6.22a5.483 5.483 0 01-2.554-.326 2.97 2.97 0 01-1.307-1.306 5.478 5.478 0 01-.326-2.553V7.218a5.478 5.478 0 01.326-2.553A2.97 2.97 0 013.666 3.36a5.484 5.484 0 012.553-.326h8.572a5.484 5.484 0 012.553.326 2.97 2.97 0 011.307 1.306c.297.753.409 1.566.326 2.371.47.003.933.108 1.357.308a2.97 2.97 0 011.307 1.306c.31.813.421 1.688.326 2.553v5.58a5.478 5.478 0 01-.326 2.552 2.97 2.97 0 01-1.307 1.306 5.483 5.483 0 01-2.553.326zM4.028 9.01v7.771a5.534 5.534 0 00.108 1.648.99.99 0 00.436.436 5.54 5.54 0 001.648.108h11.562a5.54 5.54 0 001.648-.108.989.989 0 00.436-.436c.112-.474.149-.963.109-1.448h-.997a2.99 2.99 0 01-2.114-5.103 2.99 2.99 0 012.114-.875h.997c.04-.486.003-.975-.11-1.449a.99.99 0 00-.435-.435 5.54 5.54 0 00-1.648-.109H4.027zm14.95 3.985a.997.997 0 100 1.993h.997v-1.993h-.997zM6.219 5.026a5.54 5.54 0 00-1.648.108.99.99 0 00-.436.436c-.11.456-.147.926-.108 1.394h12.978c.031-.47-.013-.94-.13-1.395a.99.99 0 00-.436-.436 5.54 5.54 0 00-1.648-.107H6.219z" />
  </svg>
);

export const Check = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.625 6.22a1 1 0 01.156 1.405l-8 10a1 1 0 01-1.488.082l-4-4a1 1 0 111.414-1.414l3.21 3.21 7.302-9.128a1 1 0 011.406-.156z"
    />
  </svg>
);

export const Profile = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.34 11.44c.41-.73.66-1.55.66-2.44 0-2.76-2.24-5-5-5S7 6.24 7 9c0 .89.25 1.72.66 2.44C6.04 12.66 5 14.54 5 16.66c0 .89.18 1.57.55 2.07.33.46.82.78 1.5.97.56.17 1.27.25 2.22.28.56.02 1.14.01 1.78 0H13.77c.33 0 .65 0 .95-.01.96-.03 1.66-.12 2.22-.28.68-.2 1.17-.52 1.5-.97.37-.51.55-1.18.55-2.07 0-2.11-1.04-4-2.66-5.22l.01.01zM9 9c0-1.65 1.35-3 3-3s3 1.35 3 3-1.35 3-3 3-3-1.35-3-3zm7.83 8.55c-.08.11-.29.19-.45.23-.39.12-.94.18-1.72.2-.54.02-1.1.01-1.7 0H9.32c-.77-.02-1.33-.09-1.72-.2-.16-.05-.37-.13-.45-.23-.04-.05-.16-.27-.16-.89 0-1.51.79-2.84 1.99-3.7.84.64 1.88 1.04 3.01 1.04s2.17-.4 3.01-1.04c1.2.85 1.99 2.18 1.99 3.7 0 .62-.12.84-.17.89h.01z" />
  </svg>
);

export const Discord = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18.942 5.294A16.309 16.309 0 0014.816 4c-.195.355-.372.721-.529 1.095a15.074 15.074 0 00-4.579 0c-.157-.374-.334-.74-.529-1.095A16.424 16.424 0 005.05 5.298c-2.611 3.939-3.319 7.78-2.965 11.566a16.511 16.511 0 005.06 2.59c.41-.561.773-1.157 1.084-1.781a10.667 10.667 0 01-1.706-.831c.143-.106.283-.215.418-.32A11.697 11.697 0 0012 17.672c1.749 0 3.476-.393 5.059-1.152.137.114.277.223.418.32a10.72 10.72 0 01-1.71.833c.312.624.674 1.22 1.084 1.78a16.434 16.434 0 005.064-2.588c.415-4.391-.71-8.197-2.973-11.572zM8.678 14.536c-.987 0-1.802-.913-1.802-2.036 0-1.122.787-2.043 1.798-2.043 1.012 0 1.82.92 1.803 2.043-.017 1.123-.794 2.036-1.8 2.036zm6.644 0c-.988 0-1.8-.913-1.8-2.036 0-1.122.787-2.043 1.8-2.043s1.816.92 1.798 2.043c-.017 1.123-.793 2.036-1.798 2.036z" />
  </svg>
);

export const X = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.059 11.041L20.976 3h-1.639l-6.006 6.982L8.533 3H3l7.255 10.558L3 21.99h1.64l6.342-7.373 5.067 7.373h5.533l-7.524-10.949zm-2.245 2.61l-.736-1.051L5.23 4.234h2.518l4.72 6.751.735 1.052 6.135 8.775H16.82l-5.007-7.16v-.001z" />
  </svg>
);

export const Telegram = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.32 20.15c.27.19.61.24.92.12.31-.12.53-.38.6-.7.72-3.4 2.48-12.02 3.14-15.11a.634.634 0 00-.22-.63.662.662 0 00-.66-.12C17.61 5 6.85 9.04 2.45 10.67c-.28.1-.46.37-.45.67 0 .3.21.55.49.64 1.97.59 4.56 1.41 4.56 1.41s1.21 3.65 1.84 5.51c.08.23.26.42.5.48s.5 0 .68-.17c1.01-.96 2.58-2.44 2.58-2.44s2.98 2.18 4.66 3.39l.01-.01zm-9.17-7.23l1.4 4.62.31-2.92s5.41-4.88 8.49-7.65c.09-.08.1-.22.03-.31a.223.223 0 00-.31-.05l-9.91 6.33-.01-.02z"
    />
  </svg>
);

export const Medium = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21.91 6.52c-.6 0-1.09 2.46-1.09 5.48 0 3.02.49 5.48 1.09 5.48.6 0 1.09-2.45 1.09-5.48 0-3.03-.49-5.48-1.09-5.48zM7.2 5.5C3.77 5.5 1 8.41 1 12s2.78 6.5 6.2 6.5c3.42 0 6.2-2.91 6.2-6.5s-2.78-6.5-6.2-6.5zM17.11 5.88c-1.71 0-3.1 2.74-3.1 6.12s1.39 6.12 3.1 6.12c1.71 0 3.1-2.74 3.1-6.12s-1.39-6.12-3.1-6.12z" />
  </svg>
);

export const ChevronDown = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.293 9.293a1 1 0 011.414 0L12 13.586l4.293-4.293a1 1 0 111.414 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414z"
    />
  </svg>
);

export const Close = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.293 5.293a1 1 0 011.414 0L12 10.586l5.293-5.293a1 1 0 111.414 1.414L13.414 12l5.293 5.293a1 1 0 01-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 01-1.414-1.414L10.586 12 5.293 6.707a1 1 0 010-1.414z"
    />
  </svg>
);

export const Replies = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 16.25h.208l.298-.008H12V19l4.316-3.15C17.972 15.016 19 13.437 19 11.72 19 9.111 16.672 7 13.8 7h-3.705C7.281 7 5 9.072 5 11.62c0 2.533 2.237 4.582 5 4.63zm7.373 1.304C19.547 16.394 21 14.21 21 11.721 21 7.827 17.589 5 13.8 5h-3.705C6.364 5 3 7.789 3 11.62c0 3.815 3.313 6.579 7 6.63V19a2 2 0 003.18 1.615l4.193-3.06z"
    />
  </svg>
);

export const Reposts = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.714 5L9.43 8.569 8.286 9.828 6.552 8.164v7.284c0 .949.751 1.724 1.677 1.724h4.61v1.724h-4.61c-1.852 0-3.353-1.543-3.353-3.448V8.164L3.143 9.828 2 8.569 5.714 5zm10.057 1.828h-4.61V5.103h4.61c1.852 0 3.353 1.544 3.353 3.449v7.284l1.733-1.664L22 15.431 18.286 19l-3.715-3.569 1.143-1.259 1.734 1.664V8.552c0-.949-.751-1.724-1.677-1.724z" />
  </svg>
);

export const Search = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={24}
      height={24}
    >
      <path d="M24 0H0v24h24V0z" />
    </mask>
    <g mask="url(#a)">
      <path d="M20.71 19.29l-4.25-4.25A7.466 7.466 0 0018 10.5C18 6.36 14.64 3 10.5 3 6.36 3 3 6.36 3 10.5c0 4.14 3.36 7.5 7.5 7.5 1.71 0 3.28-.58 4.54-1.54l4.25 4.25c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41v-.01zM10.5 16A5.51 5.51 0 015 10.5C5 7.47 7.47 5 10.5 5S16 7.47 16 10.5 13.53 16 10.5 16z" />
    </g>
  </svg>
);

export const Error = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4.075L2.691 21H21.31L12 4.075zm-1.314-1.76a1.5 1.5 0 012.628 0L23.47 20.777A1.5 1.5 0 0122.154 23H1.846A1.5 1.5 0 01.53 20.777L10.686 2.315z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 10a1 1 0 011 1v4a1 1 0 11-2 0v-4a1 1 0 011-1z"
    />
    <path d="M13 18a1 1 0 11-2 0 1 1 0 012 0z" />
  </svg>
);

export const Spinner = () => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={25}
      height={25}
    >
      <path
        d="M24.367 12.84c0 6.627-5.373 12-12 12s-12-5.373-12-12c0-6.628 5.373-12 12-12s12 5.372 12 12z"
        fill="url(#paint0_linear_44_1542)"
      />
    </mask>
    <g mask="url(#a)">
      <path d="M23.371 12.801c.55 0 1 .447.955.995A12 12 0 1111.372.843c.548-.046.995.404.995.954 0 .55-.447.99-.994 1.045a10.009 10.009 0 1010.953 10.953c.055-.547.495-.994 1.045-.994z" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_44_1542"
        x1={1.37457}
        y1={11.1934}
        x2={20.6625}
        y2={17.4928}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);

export const Edit = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M9.134 19.316L20.72 7.728A.982.982 0 0021 7.044a.92.92 0 00-.28-.662l-3.115-3.104a.95.95 0 00-1.344 0L4.655 14.844c-.57 1.763-1.555 4.823-1.626 5.08a.867.867 0 00-.03.225c0 .46.35.848.766.848.51 0 .99-.19 5.369-1.681zm-3.27-3.342L8 18.11l-3.168 1.046 1.03-3.183zm.955-1.166l10.114-10.08 2.335 2.328-10.1 10.1-2.35-2.348z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.242 19.494l-.044.015-1.468.501c-1.298.444-2.12.724-2.67.9-.731.234-1.005.29-1.295.29-.546 0-.965-.496-.965-1.047 0-.09.01-.183.036-.276v-.001c.073-.264 1.061-3.331 1.628-5.09l.015-.046 11.64-11.6a1.15 1.15 0 011.627 0L16.5 4.254 20 7.226M17.746 3.14L4.655 14.848c-.57 1.763-1.555 4.823-1.626 5.08a.867.867 0 00-.03.225c0 .46.35.848.766.848.447 0 .87-.145 3.898-1.18l1.47-.501L20.722 7.732A.982.982 0 0021 7.048c0-.23.058-.608-.14-.804m0 0L17.747 3.14l3.115 3.104zm0 0c.238.236.34.524.34.804 0 .314-.13.616-.338.825L9.242 19.494m-3.378-3.516L4.833 19.16 8 18.115l-2.137-2.137zm.09.372l-.81 2.497 2.486-.82-1.677-1.677zM16.932 4.733l2.335 2.327-10.1 10.1-2.35-2.348 10.115-10.08zM7.102 14.812l9.83-9.797 2.053 2.045-9.816 9.818-2.067-2.066z"
      />
    </g>
  </svg>
);

export const Plus = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.334 1.668a1 1 0 00-1-1h-.667a1 1 0 00-1 1v7h-7a1 1 0 00-1 1v.667a1 1 0 001 1h7v7a1 1 0 001 1h.667a1 1 0 001-1v-7h7a1 1 0 001-1v-.667a1 1 0 00-1-1h-7v-7z"
    />
  </svg>
);

export const LinkedIn = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19 3a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14zm-.5 15.5v-5.3a3.26 3.26 0 00-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 011.4 1.4v4.93h2.79zM6.88 8.56a1.68 1.68 0 001.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 00-1.69 1.69c0 .93.76 1.68 1.69 1.68zm1.39 9.94v-8.37H5.5v8.37h2.77z" />
  </svg>
);

export const Instagram = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.948 4.656c2.67 0 2.987.01 4.042.059 2.71.123 3.976 1.409 4.1 4.099.048 1.054.057 1.37.057 4.04 0 2.671-.01 2.987-.058 4.041-.124 2.688-1.386 3.976-4.099 4.1-1.055.048-1.37.058-4.041.058-2.67 0-2.987-.01-4.041-.058-2.717-.125-3.976-1.416-4.1-4.1-.048-1.055-.058-1.37-.058-4.041 0-2.67.011-2.986.058-4.041.125-2.69 1.387-3.976 4.1-4.1 1.055-.047 1.37-.057 4.04-.057zm0-1.802c-2.715 0-3.055.011-4.122.06-3.632.166-5.65 2.181-5.817 5.816-.049 1.068-.06 1.408-.06 4.124 0 2.716.011 3.056.06 4.123.166 3.632 2.181 5.65 5.816 5.817 1.068.048 1.408.06 4.123.06 2.716 0 3.057-.012 4.124-.06 3.628-.167 5.652-2.182 5.816-5.817.049-1.067.06-1.407.06-4.123s-.011-3.056-.06-4.123c-.163-3.628-2.18-5.65-5.815-5.816-1.068-.05-1.409-.061-4.125-.061zm0 4.865a5.135 5.135 0 100 10.27 5.135 5.135 0 000-10.27zm0 8.468a3.333 3.333 0 110-6.666 3.333 3.333 0 010 6.666zm5.339-9.87a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4z" />
  </svg>
);

export const Document = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.3 13a1 1 0 100 2h5a1 1 0 100-2h-5zM8.3 11a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1zM9.3 7a1 1 0 000 2h5a1 1 0 100-2h-5z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.3 21h8a3 3 0 003-3V8.414a3 3 0 00-.878-2.121l-2.415-2.414A3 3 0 0013.887 3H8.3a3 3 0 00-3 3v12a3 3 0 003 3zm-1-15a1 1 0 011-1h5.586a1 1 0 01.707.293l2.414 2.414a1 1 0 01.293.707V18a1 1 0 01-1 1h-8a1 1 0 01-1-1V6z"
    />
  </svg>
);

export const Tokenomics = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.9 13c-.5 5.053-4.765 9-9.95 9-5.523 0-10-4.477-10-10 0-5.185 3.947-9.449 9-9.95v2.012a8.001 8.001 0 001 15.938 8.001 8.001 0 007.938-7H22.9zm0-2h-2.012a8.004 8.004 0 00-6.938-6.938V2.05A10.003 10.003 0 0122.9 11z" />
  </svg>
);

export const Clock = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M23.6 12c0 6.075-4.925 11-11 11s-11-4.925-11-11 4.925-11 11-11 11 4.925 11 11zM3.607 12a8.993 8.993 0 1017.986 0 8.993 8.993 0 00-17.986 0z" />
    <path d="M12.6 5a1 1 0 00-1 1v6.467s0 .26.127.457c.085.166.217.31.39.41l4.62 2.668a1 1 0 001-1.732L13.6 11.88V6a1 1 0 00-1-1z" />
  </svg>
);

export const View = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.55 12c0 1.74 3.464 6 8 6 4.537 0 7.999-4.26 7.999-6 0-2.027-3.622-6-7.998-6-4.541 0-8 3.999-8 6zm-2 0c0-3.159 4.48-8 10-8s10 4.841 10 8c0 3.086-4.577 8-10 8-5.424 0-10-4.914-10-8zm8 0c0 1.103.897 2 2 2 1.104 0 2-.897 2-2s-.896-2-2-2c-1.103 0-2 .897-2 2zm-2 0c0-2.206 1.794-4 4-4 2.207 0 4 1.794 4 4s-1.793 4-4 4c-2.206 0-4-1.794-4-4z"
    />
  </svg>
);

export const Repost = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.914 5l3.714 3.569-1.143 1.259-1.733-1.664v7.284c0 .949.751 1.724 1.676 1.724h4.61v1.724h-4.61c-1.851 0-3.352-1.543-3.352-3.448V8.164L3.343 9.828 2.2 8.569 5.914 5zm10.057 1.828h-4.61V5.103h4.61c1.851 0 3.352 1.544 3.352 3.449v7.284l1.734-1.664 1.143 1.259L18.485 19l-3.714-3.569 1.143-1.259 1.733 1.664V8.552c0-.949-.75-1.724-1.676-1.724z" />
  </svg>
);

export const Comment = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.85 16.25h.208l.297-.008h1.495V19l4.316-3.15c1.655-.833 2.684-2.412 2.684-4.129C19.85 9.111 17.52 7 14.65 7h-3.705C8.13 7 5.85 9.072 5.85 11.62c0 2.533 2.237 4.582 5 4.63zm7.372 1.304c2.175-1.16 3.628-3.345 3.628-5.833C21.85 7.827 18.439 5 14.65 5h-3.705C7.213 5 3.85 7.789 3.85 11.62c0 3.815 3.313 6.579 7 6.63V19a2 2 0 003.179 1.615l4.193-3.06z"
    />
  </svg>
);

export const Like = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.727 5.81c-1.1-.054-2.411.463-3.501 1.958l-.725.987-.725-.987c-1.09-1.495-2.403-2.012-3.503-1.957a3.096 3.096 0 00-2.619 1.73c-.496 1.015-.57 2.52.431 4.368.967 1.785 2.932 3.869 6.416 5.989 3.483-2.12 5.447-4.204 6.414-5.99 1-1.848.927-3.352.429-4.367a3.094 3.094 0 00-2.617-1.73zm3.768 6.968c-1.216 2.247-3.6 4.64-7.541 6.95l-.453.272-.453-.272c-3.941-2.31-6.326-4.703-7.544-6.95-1.224-2.265-1.269-4.403-.462-6.043a4.874 4.874 0 014.14-2.728c1.486-.081 3.031.508 4.318 1.822 1.287-1.314 2.832-1.903 4.317-1.822a4.874 4.874 0 014.14 2.728c.807 1.64.762 3.778-.462 6.043z" />
  </svg>
);

export const Bookmark = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.15 13l4 3V6h-8v10l4-3zm0 2.5l4.4 3.3a1 1 0 001.6-.8V6a2 2 0 00-2-2h-8a2 2 0 00-2 2v12a1 1 0 001.6.8l4.4-3.3z"
    />
  </svg>
);

export const Socials = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.8 10.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM3.55 12a3.25 3.25 0 116.5 0 3.25 3.25 0 01-6.5 0zM18.8 4a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-3.25 1.25a3.25 3.25 0 116.5 0 3.25 3.25 0 01-6.5 0zM18.8 17.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-3.25 1.25a3.25 3.25 0 116.5 0 3.25 3.25 0 01-6.5 0z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.71 5.863a1 1 0 01-.381 1.362L9.25 11.769a1 1 0 11-.98-1.744l8.078-4.544a1 1 0 011.362.382zm-9.821 6.75a1 1 0 011.361-.382l8.079 4.544a1 1 0 01-.98 1.744l-8.08-4.544a1 1 0 01-.38-1.362z"
    />
  </svg>
);

export const Socials2 = () => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.677 11.906c0-4.068 3.26-7.382 7.3-7.382h.935c2.884 0 5.31 1.936 6.096 4.58a7.39 7.39 0 014.012 6.592v2.842c0 1.452-1.165 2.645-2.622 2.645h-5.614c-2.588 0-4.808-1.56-5.804-3.79H6.298c-1.457 0-2.621-1.192-2.621-2.644v-2.843zm6 5.488a4.846 4.846 0 004.107 2.29h5.614c.61 0 1.122-.504 1.122-1.146v-2.842c0-1.89-.88-3.571-2.244-4.647-.047 3.504-2.87 6.345-6.364 6.345H9.676zm1.3-11.37c-3.195 0-5.8 2.625-5.8 5.882v2.843c0 .64.51 1.145 1.121 1.145h5.614c2.678 0 4.865-2.2 4.865-4.935 0-.399-.047-.786-.134-1.156-.514-2.174-2.443-3.779-4.73-3.779h-.936zM8.729 9.485a2.434 2.434 0 112.435 2.435.75.75 0 010-1.5.934.934 0 10-.934-.935.75.75 0 01-1.5 0z"
    />
    <path d="M12.006 13.696a.842.842 0 11-1.684 0 .842.842 0 011.684 0z" />
  </svg>
);

export const Youtube = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M23.95 6.512a2.786 2.786 0 00-.766-1.27 3.05 3.05 0 00-1.338-.742c-1.878-.495-9.402-.495-9.402-.495a76.622 76.622 0 00-9.39.47c-.502.14-.962.4-1.338.76-.37.356-.638.795-.778 1.276a29.09 29.09 0 00-.488 5.494c-.012 1.841.15 3.68.488 5.494.137.479.404.916.775 1.269.37.353.833.608 1.34.743 1.904.494 9.39.494 9.39.494 3.142.036 6.281-.121 9.403-.47a3.05 3.05 0 001.338-.742 2.78 2.78 0 00.765-1.27c.345-1.811.513-3.651.5-5.495.027-1.851-.14-3.7-.5-5.517v.001zm-13.898 8.917V8.582l6.26 3.424-6.26 3.423z" />
  </svg>
);

export const External = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.987 4.55a.963.963 0 00-.14-.21.497.497 0 00-.07-.08c-.08-.07-.17-.13-.271-.18 0 0-.01-.01-.02-.01a.843.843 0 00-.35-.07H14.1c-.55 0-1 .45-1 1.001 0 .551.45 1.002 1 1.002h2.593l-3.304 3.285a.998.998 0 101.412 1.412l3.293-3.295v2.594c0 .55.451 1.001 1.002 1.001.55 0 1-.45 1-1.001V4.99c0-.12-.03-.24-.07-.35a.406.406 0 00-.05-.09h.01z" />
  </svg>
);

export const PlayButton = () => (
  <svg
    width={29}
    height={28}
    viewBox="0 0 29 28"
    preserveAspectRatio="xMinYMid"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_di_65_496)">
      <rect
        x={2.8999}
        y={2}
        width={24}
        height={24}
        rx={12}
        fill="url(#paint0_linear_65_496)"
      />
      <rect
        x={3.3999}
        y={2.5}
        width={23}
        height={23}
        rx={11.5}
        stroke="url(#paint1_linear_65_496)"
        style={{
          mixBlendMode: 'overlay',
        }}
      />
      <path
        d="M17.4 13.134a1 1 0 010 1.732l-4 2.31a1 1 0 01-1.5-.867V11.69a1 1 0 011.5-.865l4 2.309z"
        fill="#fff"
      />
    </g>
    <defs>
      <filter
        id="filter0_di_65_496"
        x={0.899902}
        y={0}
        width={28}
        height={34}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={2}
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_65_496"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_65_496" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_65_496"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={8} />
        <feGaussianBlur stdDeviation={5} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0" />
        <feBlend
          mode="overlay"
          in2="shape"
          result="effect2_innerShadow_65_496"
        />
      </filter>
      <linearGradient
        id="paint0_linear_65_496"
        x1={14.8999}
        y1={2}
        x2={14.8999}
        y2={26}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8F71FF" />
        <stop offset={1} stopColor="#6446D9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_65_496"
        x1={18.549}
        y1={2}
        x2={18.549}
        y2={25.1429}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.5} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);

export const ArbitromSepolia = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.41 7.575v8.848c0 .565.301 1.088.79 1.37l7.66 4.424c.489.282 1.09.282 1.58 0l7.659-4.425a1.58 1.58 0 00.79-1.369V7.575a1.58 1.58 0 00-.79-1.369l-7.66-4.425a1.582 1.582 0 00-1.58 0L4.2 6.206a1.578 1.578 0 00-.79 1.369z"
      fill="#213147"
    />
    <path
      d="M14.32 13.715l-1.092 2.997a.384.384 0 000 .258l1.88 5.156 2.173-1.255-2.609-7.156a.187.187 0 00-.352 0zM16.51 8.675a.187.187 0 00-.351 0l-1.092 2.997a.383.383 0 000 .258l3.078 8.443 2.174-1.256-3.808-10.442z"
      fill="#12AAFF"
    />
    <path
      d="M12.649 2.113a.33.33 0 01.155.04l8.29 4.789c.096.055.155.159.155.268v9.575a.31.31 0 01-.156.268l-8.289 4.788a.306.306 0 01-.155.041.33.33 0 01-.156-.04l-8.29-4.785a.312.312 0 01-.155-.269V7.212a.31.31 0 01.156-.269l8.289-4.788a.312.312 0 01.156-.042zm0-1.399c-.295 0-.591.076-.856.23L3.506 5.73a1.71 1.71 0 00-.856 1.482v9.574c0 .612.326 1.177.856 1.482l8.29 4.788a1.703 1.703 0 001.71 0l8.289-4.788c.53-.305.855-.87.855-1.482V7.212a1.71 1.71 0 00-.855-1.482L13.504.944a1.703 1.703 0 00-.855-.23z"
      fill="#9DCCED"
    />
    <path
      d="M7.166 20.384l.763-2.09 1.535 1.276-1.435 1.312-.863-.498z"
      fill="#213147"
    />
    <path
      d="M11.95 6.527h-2.1a.374.374 0 00-.353.246L4.993 19.128l2.173 1.256 4.96-13.605a.186.186 0 00-.175-.252zM15.628 6.527h-2.102a.374.374 0 00-.351.246L8.03 20.88l2.174 1.256 5.599-15.357a.188.188 0 00-.176-.252z"
      fill="#fff"
    />
  </svg>
);

export const Invest = () => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.951 22.854v-2.39c-1.039-.221-1.936-.647-2.69-1.277-.755-.63-1.309-1.518-1.663-2.667l2.177-.833c.294.889.73 1.565 1.31 2.028.578.463 1.338.694 2.278.694.804 0 1.486-.17 2.045-.513.559-.342.838-.875.837-1.598 0-.648-.215-1.162-.647-1.54-.431-.38-1.431-.81-3-1.293-1.686-.5-2.843-1.097-3.47-1.791-.628-.694-.941-1.542-.941-2.542 0-1.204.411-2.14 1.235-2.806.823-.667 1.667-1.046 2.53-1.139V2.854h2.352v2.333c.98.148 1.79.486 2.427 1.015a4.646 4.646 0 011.397 1.93l-2.177.888c-.235-.592-.568-1.037-1-1.333-.431-.296-1.02-.444-1.764-.444-.863 0-1.52.18-1.971.542-.45.361-.676.81-.676 1.347 0 .61.294 1.092.882 1.444.588.352 1.608.722 3.059 1.111 1.353.37 2.377.959 3.074 1.764a4.137 4.137 0 011.043 2.792c0 1.315-.411 2.315-1.235 3-.823.685-1.843 1.11-3.059 1.277v2.334h-2.353z" />
  </svg>
);

export const Quest = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M23.1 8c0-1.65-1.35-3-3-3s-3 1.35-3 3c0 1.12.63 2.09 1.55 2.61-.46.65-1.26 1.39-2.55 1.39-1.36 0-2.36-2.46-2.82-4.25A2.999 2.999 0 0015.1 5c0-1.65-1.35-3-3-3s-3 1.35-3 3c0 1.23.75 2.29 1.82 2.75C10.47 9.54 9.47 12 8.1 12c-1.29 0-2.09-.75-2.55-1.39A2.98 2.98 0 007.1 8c0-1.65-1.35-3-3-3s-3 1.35-3 3c0 1.37.93 2.52 2.19 2.87l1.84 7.37c.11.44.51.76.97.76h12c.46 0 .86-.31.97-.76l1.84-7.37c1.26-.36 2.19-1.5 2.19-2.87zm-11-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-8 3c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm13.22 10H6.88l-.86-3.44c.58.27 1.27.44 2.08.44 2 0 3.25-1.75 4-3.48.75 1.74 2 3.48 4 3.48.81 0 1.5-.17 2.08-.44L17.32 17zm2.78-8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1 12c0 .55-.45 1-1 1h-12c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1z" />
  </svg>
);

export const Pulse = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.827 5.003a1 1 0 01.908.833l1.293 7.754 1.763-5.877a1 1 0 011.92.012l1.113 3.896a1 1 0 01.925-.621h4a1 1 0 110 2H18.47l-.772 2.316a1 1 0 01-1.91-.041l-1.062-3.717-2.02 6.73a1 1 0 01-1.943-.124l-1.338-8.028-.727 2.18a1 1 0 01-.949.684h-4a1 1 0 110-2h3.28L8.8 5.684a1 1 0 011.027-.68z" />
  </svg>
);

export const Partnerships = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.33 6L.4 13.562l3.484.891 1.974-7.562L2.33 6zm-.715 6.84l1.552.398 1.468-5.624-1.582-.4-1.438 5.627zM18.814 14.464c.125.287.187.598.155.91a1.812 1.812 0 01-1.457 1.602 1.822 1.822 0 01-1.285 1.002c-.244.512-.722.89-1.296 1.01-.325.668-.97 1.012-1.674 1.012-.516 0-1.004-.183-1.356-.538-.928.404-1.902-.048-2.232-.863a1.64 1.64 0 01-1.332-.997 1.662 1.662 0 01-1.34-1.003 1.628 1.628 0 01-1.198-2.495c-.201-.05-.423-.091-.645-.132l-.106-.02.383-1.464c.524.1 1.01.219 1.453.358.913-.655 2.151-.295 2.549.679a1.639 1.639 0 011.334 1 1.638 1.638 0 011.335.998c.738.082 1.36.653 1.449 1.434l.002.225.45.402c.252.291.68.324.96.106a.616.616 0 00.075-.909l-1.457-1.279c-.157-.139.052-.38.213-.241l1.491 1.308c.257.294.692.332.969.114.285-.22.316-.631.068-.916l-1.896-1.628c-.162-.135.048-.38.208-.242l1.944 1.669c.248.282.678.335.967.114.283-.22.349-.606-.002-.995a214.39 214.39 0 01-4.143-3.796c-.355.488-2.176 1.502-3.279 1.502-1.103 0-1.779-.675-1.96-1.343-.157-.582.051-1.139.532-1.42.535-.313 1.055-.761 1.562-1.268-.789-.586-1.203-.398-2.067.013l-.003.002c-.503.237-1.099.52-1.851.645l.437-1.67c.246-.09.49-.203.734-.316 1.072-.497 2.178-1.009 3.771.233l.491-.552c.395-.447.911-.715 1.503-.715.436 0 .91.161 1.408.417l.388.204c1.27.668 2.007 1.055 3.055 1.09l.394 1.508h-.008c-1.664.03-2.54-.43-4.122-1.263l-.394-.207c-.513-.263-.859-.318-1.1-.044-.984 1.12-2.031 2.309-3.192 3.063.573.458 2.019-.458 2.592-.92.25-.201.638-.468 1.128-.468.553 0 .955.331 1.244.619.68.68 2.57 2.389 3.407 3.142.434-.242.868-.435 1.311-.605l.383 1.467a9.849 9.849 0 00-.95.461zm-11.037.875l.609-.747c.25-.3.215-.722-.08-.944-.296-.223-.737-.158-.986.14l-.61.749c-.251.298-.214.721.08.942.294.221.737.159.987-.14zm1.328 1.006l.617-.755c.248-.297.213-.722-.082-.943-.294-.221-.734-.159-.984.142l-.616.754c-.251.3-.21.712.086.936a.719.719 0 00.979-.134zm1.343.992l.608-.747c.251-.299.215-.721-.08-.944-.296-.222-.735-.157-.986.142l-.609.745c-.251.3-.213.724.082.945.293.221.734.16.985-.141zm1.865-.691c-.294-.224-.735-.159-.987.139l-.612.751c-.249.299-.213.722.082.943.295.221.735.16.986-.142l.61-.75c.253-.297.217-.72-.079-.941zm1.427 1.134l-.24-.212a1.64 1.64 0 01-.332.65l-.358.441a.732.732 0 00.448.176.68.68 0 00.415-.138c.284-.223.317-.632.067-.917zM20.915 14.453l3.484-.891L22.467 6l-3.526.891 1.974 7.562zm-.752-6.84l1.468 5.625 1.552-.397-1.438-5.627-1.582.4z"
    />
  </svg>
);

export const Roadmap = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.049 22.5h-6a1.502 1.502 0 01-1.5-1.5v-3a1.502 1.502 0 011.5-1.5h6a1.502 1.502 0 011.5 1.5v3a1.502 1.502 0 01-1.5 1.5zm-6-4.5v3h6v-3h-6zM21.049 15h-12a1.502 1.502 0 01-1.5-1.5v-3a1.502 1.502 0 011.5-1.5h12a1.502 1.502 0 011.5 1.5v3a1.502 1.502 0 01-1.5 1.5zm-12-4.5v3h12v-3h-12zM12.049 7.5h-9a1.502 1.502 0 01-1.5-1.5V3a1.502 1.502 0 011.5-1.5h9a1.502 1.502 0 011.5 1.5v3a1.501 1.501 0 01-1.5 1.5zm-9-4.5v3h9V3h-9z" />
  </svg>
);

export const Home = () => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.649 8.864l-5-4.28a2.99 2.99 0 00-3.91 0l-4.99 4.28c-.67.57-1.05 1.4-1.05 2.28v8.08c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2v-3h2v3c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2v-8.08c0-.88-.38-1.71-1.05-2.28zm-5.95 5.36h-2c-1.1 0-2 .9-2 2v3h-3v-8.08c0-.29.13-.57.35-.76l5-4.28a1 1 0 011.3 0l5 4.29c.22.19.35.47.35.76v8.08h-3v-3c0-1.1-.9-2-2-2v-.01z" />
  </svg>
);

export const Logout = () => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21.046 12.144l-4.662-4.66a.997.997 0 10-1.411 1.41l2.951 2.95-8.575.01c-.55 0-1 .45-1 1s.45 1 1 1l8.575-.01-2.951 2.95a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l4.663-4.66a.995.995 0 000-1.41l-.01.01z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.349 6.854a2 2 0 012-2h2a1 1 0 110 2h-2v12h2a1 1 0 110 2h-2a2 2 0 01-2-2v-12z"
    />
  </svg>
);

export const Github = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.649 2.854c-5.53 0-10 4.59-10 10.25 0 4.54 2.86 8.37 6.84 9.73.5.09.69-.22.69-.49 0-.24-.01-1.05-.01-1.91-2.51.47-3.16-.63-3.36-1.2-.11-.29-.6-1.2-1.03-1.45-.35-.19-.85-.67-.01-.68.79-.01 1.35.74 1.54 1.05.9 1.55 2.34 1.11 2.91.85.09-.67.35-1.11.64-1.37-2.22-.26-4.55-1.14-4.55-5.06 0-1.11.39-2.04 1.03-2.76-.1-.26-.45-1.31.1-2.72 0 0 .84-.27 2.75 1.05a9.094 9.094 0 015 0c1.91-1.33 2.75-1.05 2.75-1.05.55 1.41.2 2.46.1 2.72.64.72 1.02 1.63 1.02 2.76 0 3.93-2.34 4.81-4.56 5.06.36.32.68.94.68 1.9 0 1.37-.01 2.47-.01 2.82 0 .27.19.59.69.49 1.99-.69 3.71-2 4.93-3.74 1.22-1.75 1.88-3.84 1.88-5.99 0-5.66-4.48-10.25-10-10.25l-.02-.01z"
    />
  </svg>
);

export const World = () => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.999 2.854c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10 5.522 0 10-4.478 10-10 0-5.523-4.478-10-10-10zm.833 13.38v-2.547h2.495c-.05.953-.177 1.867-.38 2.733-.686-.1-1.395-.157-2.115-.185zm1.63 1.802c-.415 1.109-.965 2.081-1.63 2.88V17.9c.555.023 1.1.067 1.63.136zm-1.63-6.016V9.508a20.149 20.149 0 002.123-.187c.199.856.325 1.76.372 2.7h-2.495zm0-4.178v-3.05c.672.807 1.226 1.79 1.643 2.913-.535.07-1.084.114-1.643.137zm2.253-2.722a8.357 8.357 0 012.741 1.788c-.535.195-1.092.368-1.682.506a12.773 12.773 0 00-1.06-2.294zM9.05 16.42a15.358 15.358 0 01-.38-2.733h2.495v2.548c-.72.028-1.428.085-2.115.185zm2.115 1.48v3.016c-.665-.799-1.215-1.771-1.63-2.88.531-.069 1.075-.113 1.63-.136zM8.67 12.02c.048-.94.173-1.843.372-2.699.69.101 1.4.159 2.123.187v2.512H8.67zm.854-4.315c.416-1.122.97-2.106 1.641-2.914v3.051a18.624 18.624 0 01-1.641-.137zm-1.671-.292c-.59-.138-1.148-.31-1.682-.506A8.365 8.365 0 018.913 5.12a12.882 12.882 0 00-1.06 2.294zM7.395 9.01c-.22.96-.361 1.967-.41 3.01H3.708a8.271 8.271 0 011.347-3.766c.734.301 1.514.559 2.34.756zm.008 7.719a16 16 0 00-2.33.75 8.27 8.27 0 01-1.365-3.793h3.278c.049 1.054.193 2.073.417 3.043zm.46 1.597c.286.813.64 1.568 1.048 2.26a8.342 8.342 0 01-2.713-1.762c.53-.191 1.082-.363 1.666-.498zm8.27 0c.584.136 1.136.306 1.667.498a8.382 8.382 0 01-2.715 1.763 12.9 12.9 0 001.049-2.26zm.462-1.597c.225-.97.368-1.989.417-3.043h3.278a8.278 8.278 0 01-1.365 3.793 16.03 16.03 0 00-2.33-.75zm.417-4.71a17.055 17.055 0 00-.41-3.009 15.896 15.896 0 002.34-.756 8.28 8.28 0 011.348 3.765h-3.278z" />
  </svg>
);

export const Voice = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.299 3.854a1 1 0 01.993.883l.007.117v16a1 1 0 01-1.993.117l-.007-.117v-16a1 1 0 011-1zm-4 3a1 1 0 011 1v10a1 1 0 01-2 0v-10a1 1 0 011-1zm8 0a1 1 0 011 1v10a1 1 0 01-2 0v-10a1 1 0 011-1zm-12 3a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zm16 0a1 1 0 01.993.883l.007.117v4a1 1 0 01-1.993.117l-.007-.117v-4a1 1 0 011-1z" />
  </svg>
);

export const PlayVideo = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.095 12.243a.875.875 0 010 1.515l-6.56 3.788a.875.875 0 01-1.313-.758V9.212a.875.875 0 011.312-.757l6.561 3.788z" />
    <path d="M23.6 13c0 6.075-4.925 11-11 11s-11-4.925-11-11 4.925-11 11-11 11 4.925 11 11zM3.607 13a8.993 8.993 0 1017.986 0 8.993 8.993 0 00-17.986 0z" />
  </svg>
);

export const Growth = () => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.398 14.354v5h2v-5h-2zm-.5-1.5a1 1 0 00-1 1v6a1 1 0 001 1h3a1 1 0 001-1v-6a1 1 0 00-1-1h-3zM11.898 10.354v9h2v-9h-2zm-.5-1.5a1 1 0 00-1 1v10a1 1 0 001 1h3a1 1 0 001-1v-10a1 1 0 00-1-1h-3zM18.398 6.354v13h2v-13h-2zm-.5-1.5a1 1 0 00-1 1v14a1 1 0 001 1h3a1 1 0 001-1v-14a1 1 0 00-1-1h-3z"
    />
  </svg>
);

export const Money = () => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M20.59 16.875H4.507a.804.804 0 100 1.608H20.59a.804.804 0 000-1.608zm0 3.217H4.507a.804.804 0 000 1.609H20.59a.805.805 0 000-1.609zM7.724 8.832a.804.804 0 100 1.61.804.804 0 000-1.61zm11.26-4.825H6.113A2.413 2.413 0 003.702 6.42v6.434a2.413 2.413 0 002.412 2.413h12.868a2.412 2.412 0 002.413-2.413V6.42a2.413 2.413 0 00-2.413-2.413zm.804 8.847a.804.804 0 01-.805.804H6.114a.804.804 0 01-.804-.804V6.42a.804.804 0 01.804-.804h12.868a.804.804 0 01.805.804v6.434zm-7.239-5.63a2.412 2.412 0 100 4.825 2.412 2.412 0 000-4.825zm0 3.217a.804.804 0 110-1.608.804.804 0 010 1.608zm4.826-1.608a.804.804 0 100 1.608.804.804 0 000-1.608z" />
  </svg>
);

export const Showcase = () => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.198 2.494c.424 0 .768.343.768.767v1.151h4.029a3.645 3.645 0 013.645 3.645v7.675a3.645 3.645 0 01-3.368 3.634l1.368 2.737a.767.767 0 01-1.373.686l-1.706-3.412h-2.595v2.11a.767.767 0 11-1.535 0v-2.11H8.836L7.129 22.79a.767.767 0 11-1.373-.687l1.369-2.737a3.645 3.645 0 01-3.368-3.634V8.056a3.645 3.645 0 013.645-3.645h4.029v-1.15c0-.425.344-.768.767-.768zM7.402 5.947a2.11 2.11 0 00-2.11 2.11v7.675a2.11 2.11 0 002.11 2.11h9.593a2.11 2.11 0 002.11-2.11V8.056a2.11 2.11 0 00-2.11-2.11H7.402z"
    />
  </svg>
);

export const QuestTesting = () => (
  <svg
    width={127}
    height={28}
    viewBox="0 0 127 28"
    fill="none"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_137_582)">
      <path
        d="M113.049.728h-100c-6.904 0-12.5 5.597-12.5 12.5 0 6.904 5.596 12.5 12.5 12.5h100c6.903 0 12.5-5.596 12.5-12.5 0-6.903-5.597-12.5-12.5-12.5z"
        stroke="url(#paint0_linear_137_582)"
      />
      <path
        d="M41.617 18.228h-1.608v-9.6h2.004l4.056 7.116-.012-7.116h1.608v9.6H45.66l-4.056-7.14h-.012l.024 7.14zm9.61-4.2V16.8h4.656v1.428h-6.3v-9.6h6.168v1.428h-4.524v2.568h4.092v1.404h-4.092zm7.52 4.2l-2.28-9.6h1.655l1.74 7.536 1.848-7.536h1.884l1.86 7.584 1.752-7.584h1.632l-2.28 9.6H64.35l-1.716-6.984-1.716 6.984h-2.172zm18.762.096c-2.724 0-4.56-1.98-4.56-4.896s1.836-4.896 4.56-4.896c2.724 0 4.56 1.98 4.56 4.896 0 1.56-.528 2.844-1.428 3.708l1.344 1.752h-1.908l-.732-.912a4.723 4.723 0 01-1.836.348zm-.54-3.336h2.004l.648.84c.456-.6.732-1.428.732-2.388 0-2.016-1.2-3.48-2.844-3.48s-2.844 1.464-2.844 3.48c0 2.004 1.188 3.456 2.844 3.456.3 0 .588-.048.852-.144l-1.392-1.764zm12.29-.528V8.628h1.656v5.868c0 2.436-1.38 3.828-3.816 3.828s-3.804-1.392-3.804-3.828V8.628h1.644v5.832c0 1.512.816 2.436 2.16 2.436 1.344 0 2.16-.924 2.16-2.436zm5.081-.432V16.8h4.656v1.428h-6.3v-9.6h6.168v1.428H94.34v2.568h4.092v1.404H94.34zm11.324 1.56c0-.744-.564-1.248-1.596-1.416l-1.296-.204c-1.728-.276-2.712-1.26-2.712-2.712 0-1.692 1.32-2.724 3.492-2.724 2.112 0 3.384.972 3.648 2.808h-1.704c-.216-.9-.888-1.38-1.968-1.38-1.092 0-1.752.48-1.752 1.236 0 .66.492 1.08 1.44 1.236l1.26.216c1.86.312 2.892 1.332 2.892 2.856 0 1.74-1.368 2.82-3.576 2.82s-3.696-1.092-3.996-2.94h1.704c.228.948 1.104 1.512 2.34 1.512 1.14 0 1.824-.492 1.824-1.308zm6.573 2.64h-1.656v-8.172h-2.904V8.628h7.476v1.428h-2.916v8.172z"
        fill="#fff"
      />
      <path
        d="M23.498 10.331c-1.148-1.216-1.21-2.517 1.149-5.015.093-.099.074-.264-.04-.331-2.12-1.245-4.19-.957-5.935.89-1.637 1.734-1.977 3.77-1.04 5.87a.202.202 0 01-.045.228 60.548 60.548 0 00-2.471 2.438 61.365 61.365 0 00-2.303 2.616c-.872 1.034-1.059 2.644-.242 3.727.128.17.263.333.41.488.146.155.3.298.46.433 1.023.865 2.543.667 3.52-.255a60.611 60.611 0 002.47-2.44 61.295 61.295 0 002.304-2.615.176.176 0 01.214-.048c1.983.992 3.907.632 5.545-1.102 1.688-1.787 1.997-3.897.95-6.066a.127.127 0 00-.209-.033c-2.359 2.497-3.588 2.431-4.737 1.215z"
        stroke="#fff"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_137_582"
        x1={63.4774}
        y1={13.7098}
        x2={126.049}
        y2={13.7098}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AFB6BE" stopOpacity={0.3} />
        <stop offset={1} stopColor="#AFB6BE" />
      </linearGradient>
      <clipPath id="clip0_137_582">
        <path fill="#fff" transform="translate(.049 .228)" d="M0 0H126V27H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const QuestBurn = () => (
  <svg
    width={127}
    height={28}
    viewBox="0 0 127 28"
    fill="none"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_137_546)">
      <path
        d="M113.049.728h-100c-6.904 0-12.5 5.597-12.5 12.5 0 6.904 5.596 12.5 12.5 12.5h100c6.903 0 12.5-5.596 12.5-12.5 0-6.903-5.597-12.5-12.5-12.5z"
        stroke="url(#paint0_linear_137_546)"
      />
      <path
        d="M41.617 18.228h-1.608v-9.6h2.004l4.056 7.116-.012-7.116h1.608v9.6H45.66l-4.056-7.14h-.012l.024 7.14zm9.61-4.2V16.8h4.656v1.428h-6.3v-9.6h6.168v1.428h-4.524v2.568h4.092v1.404h-4.092zm7.52 4.2l-2.28-9.6h1.655l1.74 7.536 1.848-7.536h1.884l1.86 7.584 1.752-7.584h1.632l-2.28 9.6H64.35l-1.716-6.984-1.716 6.984h-2.172zm18.762.096c-2.724 0-4.56-1.98-4.56-4.896s1.836-4.896 4.56-4.896c2.724 0 4.56 1.98 4.56 4.896 0 1.56-.528 2.844-1.428 3.708l1.344 1.752h-1.908l-.732-.912a4.723 4.723 0 01-1.836.348zm-.54-3.336h2.004l.648.84c.456-.6.732-1.428.732-2.388 0-2.016-1.2-3.48-2.844-3.48s-2.844 1.464-2.844 3.48c0 2.004 1.188 3.456 2.844 3.456.3 0 .588-.048.852-.144l-1.392-1.764zm12.29-.528V8.628h1.656v5.868c0 2.436-1.38 3.828-3.816 3.828s-3.804-1.392-3.804-3.828V8.628h1.644v5.832c0 1.512.816 2.436 2.16 2.436 1.344 0 2.16-.924 2.16-2.436zm5.081-.432V16.8h4.656v1.428h-6.3v-9.6h6.168v1.428H94.34v2.568h4.092v1.404H94.34zm11.324 1.56c0-.744-.564-1.248-1.596-1.416l-1.296-.204c-1.728-.276-2.712-1.26-2.712-2.712 0-1.692 1.32-2.724 3.492-2.724 2.112 0 3.384.972 3.648 2.808h-1.704c-.216-.9-.888-1.38-1.968-1.38-1.092 0-1.752.48-1.752 1.236 0 .66.492 1.08 1.44 1.236l1.26.216c1.86.312 2.892 1.332 2.892 2.856 0 1.74-1.368 2.82-3.576 2.82s-3.696-1.092-3.996-2.94h1.704c.228.948 1.104 1.512 2.34 1.512 1.14 0 1.824-.492 1.824-1.308zm6.573 2.64h-1.656v-8.172h-2.904V8.628h7.476v1.428h-2.916v8.172z"
        fill="#fff"
      />
      <path
        d="M19.104 3.309a.569.569 0 00-.583 0 .38.38 0 00-.088.496c1.795 3.107 2.174 7.337-.277 9.671a8.052 8.052 0 01-2.188-2.917 5.675 5.675 0 00-2.917 5.105c.153 3.795 2.596 6.564 7.293 6.564s7.133-2.917 7.294-6.564c.19-4.376-2.918-9.759-8.534-12.355zM23.99 15.666a2.918 2.918 0 01-2.916 2.917"
        stroke="#fff"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_137_546"
        x1={63.4774}
        y1={13.7098}
        x2={126.049}
        y2={13.7098}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AFB6BE" stopOpacity={0.3} />
        <stop offset={1} stopColor="#AFB6BE" />
      </linearGradient>
      <clipPath id="clip0_137_546">
        <path fill="#fff" transform="translate(.049 .228)" d="M0 0H126V27H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const QuestDiscord = () => (
  <svg
    width={127}
    height={28}
    viewBox="0 0 127 28"
    fill="none"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_137_552)">
      <path
        d="M113.049.728h-100c-6.904 0-12.5 5.597-12.5 12.5 0 6.904 5.596 12.5 12.5 12.5h100c6.903 0 12.5-5.596 12.5-12.5 0-6.903-5.597-12.5-12.5-12.5z"
        stroke="url(#paint0_linear_137_552)"
      />
      <path
        d="M41.617 18.228h-1.608v-9.6h2.004l4.056 7.116-.012-7.116h1.608v9.6H45.66l-4.056-7.14h-.012l.024 7.14zm9.61-4.2V16.8h4.656v1.428h-6.3v-9.6h6.168v1.428h-4.524v2.568h4.092v1.404h-4.092zm7.52 4.2l-2.28-9.6h1.655l1.74 7.536 1.848-7.536h1.884l1.86 7.584 1.752-7.584h1.632l-2.28 9.6H64.35l-1.716-6.984-1.716 6.984h-2.172zm18.762.096c-2.724 0-4.56-1.98-4.56-4.896s1.836-4.896 4.56-4.896c2.724 0 4.56 1.98 4.56 4.896 0 1.56-.528 2.844-1.428 3.708l1.344 1.752h-1.908l-.732-.912a4.723 4.723 0 01-1.836.348zm-.54-3.336h2.004l.648.84c.456-.6.732-1.428.732-2.388 0-2.016-1.2-3.48-2.844-3.48s-2.844 1.464-2.844 3.48c0 2.004 1.188 3.456 2.844 3.456.3 0 .588-.048.852-.144l-1.392-1.764zm12.29-.528V8.628h1.656v5.868c0 2.436-1.38 3.828-3.816 3.828s-3.804-1.392-3.804-3.828V8.628h1.644v5.832c0 1.512.816 2.436 2.16 2.436 1.344 0 2.16-.924 2.16-2.436zm5.081-.432V16.8h4.656v1.428h-6.3v-9.6h6.168v1.428H94.34v2.568h4.092v1.404H94.34zm11.324 1.56c0-.744-.564-1.248-1.596-1.416l-1.296-.204c-1.728-.276-2.712-1.26-2.712-2.712 0-1.692 1.32-2.724 3.492-2.724 2.112 0 3.384.972 3.648 2.808h-1.704c-.216-.9-.888-1.38-1.968-1.38-1.092 0-1.752.48-1.752 1.236 0 .66.492 1.08 1.44 1.236l1.26.216c1.86.312 2.892 1.332 2.892 2.856 0 1.74-1.368 2.82-3.576 2.82s-3.696-1.092-3.996-2.94h1.704c.228.948 1.104 1.512 2.34 1.512 1.14 0 1.824-.492 1.824-1.308zm6.573 2.64h-1.656v-8.172h-2.904V8.628h7.476v1.428h-2.916v8.172z"
        fill="#fff"
      />
      <path
        d="M27.673 6.555a18.783 18.783 0 00-4.478-1.326.07.07 0 00-.072.033c-.194.328-.408.756-.558 1.093a17.544 17.544 0 00-5.03 0c-.15-.344-.371-.765-.566-1.093a.072.072 0 00-.072-.033c-1.571.259-3.075.71-4.478 1.326a.063.063 0 00-.03.024c-2.851 4.065-3.633 8.031-3.25 11.948.002.019.014.037.03.049a18.6 18.6 0 005.493 2.65.073.073 0 00.077-.025c.423-.551.8-1.133 1.124-1.744.019-.036 0-.078-.038-.092a12.276 12.276 0 01-1.716-.78.066.066 0 01-.007-.113c.115-.082.23-.168.34-.254a.07.07 0 01.072-.01c3.6 1.569 7.498 1.569 11.056 0a.07.07 0 01.072.009c.11.086.225.173.341.256a.066.066 0 01-.006.111 11.51 11.51 0 01-1.717.78.066.066 0 00-.037.093c.33.61.708 1.192 1.123 1.743a.072.072 0 00.077.025 18.54 18.54 0 005.503-2.65.067.067 0 00.028-.047c.459-4.528-.768-8.462-3.253-11.948a.055.055 0 00-.028-.025zM16.4 16.142c-1.085 0-1.978-.95-1.978-2.116 0-1.166.876-2.115 1.978-2.115 1.11 0 1.994.957 1.977 2.115 0 1.166-.876 2.116-1.977 2.116zm7.31 0c-1.084 0-1.977-.95-1.977-2.116 0-1.166.875-2.115 1.977-2.115 1.11 0 1.994.957 1.977 2.115 0 1.166-.867 2.116-1.977 2.116z"
        stroke="#fff"
        strokeWidth={1.4}
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_137_552"
        x1={63.4774}
        y1={13.7098}
        x2={126.049}
        y2={13.7098}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AFB6BE" stopOpacity={0.3} />
        <stop offset={1} stopColor="#AFB6BE" />
      </linearGradient>
      <clipPath id="clip0_137_552">
        <path fill="#fff" transform="translate(.049 .228)" d="M0 0H126V27H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const QuestHodl = () => (
  <svg
    width={127}
    height={28}
    viewBox="0 0 127 28"
    fill="none"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_137_557)">
      <path
        d="M113.049.728h-100c-6.904 0-12.5 5.597-12.5 12.5 0 6.904 5.596 12.5 12.5 12.5h100c6.903 0 12.5-5.596 12.5-12.5 0-6.903-5.597-12.5-12.5-12.5z"
        stroke="url(#paint0_linear_137_557)"
      />
      <path
        d="M41.617 18.228h-1.608v-9.6h2.004l4.056 7.116-.012-7.116h1.608v9.6H45.66l-4.056-7.14h-.012l.024 7.14zm9.61-4.2V16.8h4.656v1.428h-6.3v-9.6h6.168v1.428h-4.524v2.568h4.092v1.404h-4.092zm7.52 4.2l-2.28-9.6h1.655l1.74 7.536 1.848-7.536h1.884l1.86 7.584 1.752-7.584h1.632l-2.28 9.6H64.35l-1.716-6.984-1.716 6.984h-2.172zm18.762.096c-2.724 0-4.56-1.98-4.56-4.896s1.836-4.896 4.56-4.896c2.724 0 4.56 1.98 4.56 4.896 0 1.56-.528 2.844-1.428 3.708l1.344 1.752h-1.908l-.732-.912a4.723 4.723 0 01-1.836.348zm-.54-3.336h2.004l.648.84c.456-.6.732-1.428.732-2.388 0-2.016-1.2-3.48-2.844-3.48s-2.844 1.464-2.844 3.48c0 2.004 1.188 3.456 2.844 3.456.3 0 .588-.048.852-.144l-1.392-1.764zm12.29-.528V8.628h1.656v5.868c0 2.436-1.38 3.828-3.816 3.828s-3.804-1.392-3.804-3.828V8.628h1.644v5.832c0 1.512.816 2.436 2.16 2.436 1.344 0 2.16-.924 2.16-2.436zm5.081-.432V16.8h4.656v1.428h-6.3v-9.6h6.168v1.428H94.34v2.568h4.092v1.404H94.34zm11.324 1.56c0-.744-.564-1.248-1.596-1.416l-1.296-.204c-1.728-.276-2.712-1.26-2.712-2.712 0-1.692 1.32-2.724 3.492-2.724 2.112 0 3.384.972 3.648 2.808h-1.704c-.216-.9-.888-1.38-1.968-1.38-1.092 0-1.752.48-1.752 1.236 0 .66.492 1.08 1.44 1.236l1.26.216c1.86.312 2.892 1.332 2.892 2.856 0 1.74-1.368 2.82-3.576 2.82s-3.696-1.092-3.996-2.94h1.704c.228.948 1.104 1.512 2.34 1.512 1.14 0 1.824-.492 1.824-1.308zm6.573 2.64h-1.656v-8.172h-2.904V8.628h7.476v1.428h-2.916v8.172z"
        fill="#fff"
      />
      <path
        d="M20.049 21.478v.917M26.53 6.746l-.648.648M14.215 19.062l-.648.648M29.215 13.228H28.3M26.53 19.71l-.648-.648"
        stroke="#fff"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        d="M10.882 13.229a9.167 9.167 0 109.167-9.167m-9.167 9.167a9.167 9.167 0 019.167-9.167m-9.167 9.167h.917m8.25-9.167v.917m-5.834 2.416l-.648-.648m6.482 11.982a5.502 5.502 0 01-5.187-3.667h10.374a5.502 5.502 0 01-5.187 3.667zm0-11a5.502 5.502 0 015.187 3.667H14.862a5.502 5.502 0 015.187-3.667z"
        stroke="#fff"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_137_557"
        x1={63.4774}
        y1={13.7098}
        x2={126.049}
        y2={13.7098}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AFB6BE" stopOpacity={0.3} />
        <stop offset={1} stopColor="#AFB6BE" />
      </linearGradient>
      <clipPath id="clip0_137_557">
        <path fill="#fff" transform="translate(.049 .228)" d="M0 0H126V27H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const QuestReading = () => (
  <svg
    width={127}
    height={28}
    viewBox="0 0 127 28"
    fill="none"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_137_567)">
      <path
        d="M113.049.728h-100c-6.904 0-12.5 5.597-12.5 12.5 0 6.904 5.596 12.5 12.5 12.5h100c6.903 0 12.5-5.596 12.5-12.5 0-6.903-5.597-12.5-12.5-12.5z"
        stroke="url(#paint0_linear_137_567)"
      />
      <path
        d="M41.617 18.228h-1.608v-9.6h2.004l4.056 7.116-.012-7.116h1.608v9.6H45.66l-4.056-7.14h-.012l.024 7.14zm9.61-4.2V16.8h4.656v1.428h-6.3v-9.6h6.168v1.428h-4.524v2.568h4.092v1.404h-4.092zm7.52 4.2l-2.28-9.6h1.655l1.74 7.536 1.848-7.536h1.884l1.86 7.584 1.752-7.584h1.632l-2.28 9.6H64.35l-1.716-6.984-1.716 6.984h-2.172zm18.762.096c-2.724 0-4.56-1.98-4.56-4.896s1.836-4.896 4.56-4.896c2.724 0 4.56 1.98 4.56 4.896 0 1.56-.528 2.844-1.428 3.708l1.344 1.752h-1.908l-.732-.912a4.723 4.723 0 01-1.836.348zm-.54-3.336h2.004l.648.84c.456-.6.732-1.428.732-2.388 0-2.016-1.2-3.48-2.844-3.48s-2.844 1.464-2.844 3.48c0 2.004 1.188 3.456 2.844 3.456.3 0 .588-.048.852-.144l-1.392-1.764zm12.29-.528V8.628h1.656v5.868c0 2.436-1.38 3.828-3.816 3.828s-3.804-1.392-3.804-3.828V8.628h1.644v5.832c0 1.512.816 2.436 2.16 2.436 1.344 0 2.16-.924 2.16-2.436zm5.081-.432V16.8h4.656v1.428h-6.3v-9.6h6.168v1.428H94.34v2.568h4.092v1.404H94.34zm11.324 1.56c0-.744-.564-1.248-1.596-1.416l-1.296-.204c-1.728-.276-2.712-1.26-2.712-2.712 0-1.692 1.32-2.724 3.492-2.724 2.112 0 3.384.972 3.648 2.808h-1.704c-.216-.9-.888-1.38-1.968-1.38-1.092 0-1.752.48-1.752 1.236 0 .66.492 1.08 1.44 1.236l1.26.216c1.86.312 2.892 1.332 2.892 2.856 0 1.74-1.368 2.82-3.576 2.82s-3.696-1.092-3.996-2.94h1.704c.228.948 1.104 1.512 2.34 1.512 1.14 0 1.824-.492 1.824-1.308zm6.573 2.64h-1.656v-8.172h-2.904V8.628h7.476v1.428h-2.916v8.172z"
        fill="#fff"
      />
      <path
        d="M13.632 10.795c1.16.18 2.455.479 3.667.947m-3.667 2.72c.586.09 1.207.212 1.833.37m4.584-6.055V21.84M12.71 5.989c2.034.23 4.766.848 6.712 2.212.375.262.879.262 1.253 0 1.947-1.364 4.679-1.983 6.712-2.212 1.007-.114 1.828.726 1.828 1.763v10.326c0 1.037-.821 1.878-1.828 1.992-2.033.23-4.765.848-6.712 2.212a1.096 1.096 0 01-1.253 0c-1.946-1.364-4.678-1.983-6.712-2.212-1.006-.114-1.828-.955-1.828-1.992V7.752c0-1.037.822-1.877 1.828-1.763z"
        stroke="#fff"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_137_567"
        x1={63.4774}
        y1={13.7098}
        x2={126.049}
        y2={13.7098}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AFB6BE" stopOpacity={0.3} />
        <stop offset={1} stopColor="#AFB6BE" />
      </linearGradient>
      <clipPath id="clip0_137_567">
        <path fill="#fff" transform="translate(.049 .228)" d="M0 0H126V27H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const QuestReport = () => (
  <svg
    width={127}
    height={28}
    viewBox="0 0 127 28"
    fill="none"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_137_572)">
      <path
        d="M113.049.728h-100c-6.904 0-12.5 5.597-12.5 12.5 0 6.904 5.596 12.5 12.5 12.5h100c6.903 0 12.5-5.596 12.5-12.5 0-6.903-5.597-12.5-12.5-12.5z"
        stroke="url(#paint0_linear_137_572)"
      />
      <path
        d="M41.617 18.228h-1.608v-9.6h2.004l4.056 7.116-.012-7.116h1.608v9.6H45.66l-4.056-7.14h-.012l.024 7.14zm9.61-4.2V16.8h4.656v1.428h-6.3v-9.6h6.168v1.428h-4.524v2.568h4.092v1.404h-4.092zm7.52 4.2l-2.28-9.6h1.655l1.74 7.536 1.848-7.536h1.884l1.86 7.584 1.752-7.584h1.632l-2.28 9.6H64.35l-1.716-6.984-1.716 6.984h-2.172zm18.762.096c-2.724 0-4.56-1.98-4.56-4.896s1.836-4.896 4.56-4.896c2.724 0 4.56 1.98 4.56 4.896 0 1.56-.528 2.844-1.428 3.708l1.344 1.752h-1.908l-.732-.912a4.723 4.723 0 01-1.836.348zm-.54-3.336h2.004l.648.84c.456-.6.732-1.428.732-2.388 0-2.016-1.2-3.48-2.844-3.48s-2.844 1.464-2.844 3.48c0 2.004 1.188 3.456 2.844 3.456.3 0 .588-.048.852-.144l-1.392-1.764zm12.29-.528V8.628h1.656v5.868c0 2.436-1.38 3.828-3.816 3.828s-3.804-1.392-3.804-3.828V8.628h1.644v5.832c0 1.512.816 2.436 2.16 2.436 1.344 0 2.16-.924 2.16-2.436zm5.081-.432V16.8h4.656v1.428h-6.3v-9.6h6.168v1.428H94.34v2.568h4.092v1.404H94.34zm11.324 1.56c0-.744-.564-1.248-1.596-1.416l-1.296-.204c-1.728-.276-2.712-1.26-2.712-2.712 0-1.692 1.32-2.724 3.492-2.724 2.112 0 3.384.972 3.648 2.808h-1.704c-.216-.9-.888-1.38-1.968-1.38-1.092 0-1.752.48-1.752 1.236 0 .66.492 1.08 1.44 1.236l1.26.216c1.86.312 2.892 1.332 2.892 2.856 0 1.74-1.368 2.82-3.576 2.82s-3.696-1.092-3.996-2.94h1.704c.228.948 1.104 1.512 2.34 1.512 1.14 0 1.824-.492 1.824-1.308zm6.573 2.64h-1.656v-8.172h-2.904V8.628h7.476v1.428h-2.916v8.172zM26.924 18.062a.75.75 0 000 1.5v-1.5zm-9.167 1.5a.75.75 0 000-1.5v1.5zM14.55 8.895a.75.75 0 000 1.5v-1.5zm11 1.5a.75.75 0 000-1.5v1.5zm-11 2.167a.75.75 0 000 1.5v-1.5zm3.666 1.5a.75.75 0 000-1.5v1.5zm3.5 5.208a.75.75 0 00-1.5 0h1.5zm-.75 3.208h-.75a.75.75 0 001.086.671l-.336-.67zm1.834-.916l.335-.671a.75.75 0 00-.67 0l.335.67zm1.833.916l-.335.671a.75.75 0 001.085-.67h-.75zm.75-3.208a.75.75 0 00-1.5 0h1.5zm3.083-11.458v9.166h1.5V7.812h-1.5zm-16.833 9.166V7.812h-1.5v9.166h1.5zm1.083-10.25h14.667v-1.5H12.715v1.5zm14.667 11.334h-.458v1.5h.458v-1.5zm-9.625 0h-5.042v1.5h5.042v-1.5zm-6.125-10.25c0-.599.485-1.084 1.083-1.084v-1.5a2.583 2.583 0 00-2.583 2.584h1.5zm-1.5 9.166a2.583 2.583 0 002.583 2.584v-1.5a1.083 1.083 0 01-1.083-1.084h-1.5zm18.333 0c0 .599-.485 1.084-1.083 1.084v1.5a2.583 2.583 0 002.583-2.584h-1.5zm1.5-9.166a2.583 2.583 0 00-2.583-2.584v1.5c.598 0 1.083.485 1.083 1.084h1.5zM24.8 16.978a2 2 0 01-2 2v1.5a3.5 3.5 0 003.5-3.5h-1.5zm-2 2a2 2 0 01-2-2h-1.5a3.5 3.5 0 003.5 3.5v-1.5zm-2-2a2 2 0 012-2v-1.5a3.5 3.5 0 00-3.5 3.5h1.5zm2-2a2 2 0 012 2h1.5a3.5 3.5 0 00-3.5-3.5v1.5zm-8.25-4.583h11v-1.5h-11v1.5zm0 3.667h3.666v-1.5H14.55v1.5zm5.666 5.208v3.208h1.5V19.27h-1.5zm1.086 3.88l1.833-.917-.67-1.342-1.834.917.67 1.341zm1.162-.917l1.834.916.67-1.341-1.833-.917-.67 1.342zm2.92.245V19.27h-1.5v3.208h1.5z"
        fill="#fff"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_137_572"
        x1={63.4774}
        y1={13.7098}
        x2={126.049}
        y2={13.7098}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AFB6BE" stopOpacity={0.3} />
        <stop offset={1} stopColor="#AFB6BE" />
      </linearGradient>
      <clipPath id="clip0_137_572">
        <path fill="#fff" transform="translate(.049 .228)" d="M0 0H126V27H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const QuestWinning = () => (
  <svg
    width={127}
    height={28}
    viewBox="0 0 127 28"
    fill="none"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_137_577)">
      <path
        d="M113.049.728h-100c-6.904 0-12.5 5.597-12.5 12.5 0 6.904 5.596 12.5 12.5 12.5h100c6.903 0 12.5-5.596 12.5-12.5 0-6.903-5.597-12.5-12.5-12.5z"
        stroke="url(#paint0_linear_137_577)"
      />
      <path
        d="M41.617 18.228h-1.608v-9.6h2.004l4.056 7.116-.012-7.116h1.608v9.6H45.66l-4.056-7.14h-.012l.024 7.14zm9.61-4.2V16.8h4.656v1.428h-6.3v-9.6h6.168v1.428h-4.524v2.568h4.092v1.404h-4.092zm7.52 4.2l-2.28-9.6h1.655l1.74 7.536 1.848-7.536h1.884l1.86 7.584 1.752-7.584h1.632l-2.28 9.6H64.35l-1.716-6.984-1.716 6.984h-2.172zm18.762.096c-2.724 0-4.56-1.98-4.56-4.896s1.836-4.896 4.56-4.896c2.724 0 4.56 1.98 4.56 4.896 0 1.56-.528 2.844-1.428 3.708l1.344 1.752h-1.908l-.732-.912a4.723 4.723 0 01-1.836.348zm-.54-3.336h2.004l.648.84c.456-.6.732-1.428.732-2.388 0-2.016-1.2-3.48-2.844-3.48s-2.844 1.464-2.844 3.48c0 2.004 1.188 3.456 2.844 3.456.3 0 .588-.048.852-.144l-1.392-1.764zm12.29-.528V8.628h1.656v5.868c0 2.436-1.38 3.828-3.816 3.828s-3.804-1.392-3.804-3.828V8.628h1.644v5.832c0 1.512.816 2.436 2.16 2.436 1.344 0 2.16-.924 2.16-2.436zm5.081-.432V16.8h4.656v1.428h-6.3v-9.6h6.168v1.428H94.34v2.568h4.092v1.404H94.34zm11.324 1.56c0-.744-.564-1.248-1.596-1.416l-1.296-.204c-1.728-.276-2.712-1.26-2.712-2.712 0-1.692 1.32-2.724 3.492-2.724 2.112 0 3.384.972 3.648 2.808h-1.704c-.216-.9-.888-1.38-1.968-1.38-1.092 0-1.752.48-1.752 1.236 0 .66.492 1.08 1.44 1.236l1.26.216c1.86.312 2.892 1.332 2.892 2.856 0 1.74-1.368 2.82-3.576 2.82s-3.696-1.092-3.996-2.94h1.704c.228.948 1.104 1.512 2.34 1.512 1.14 0 1.824-.492 1.824-1.308zm6.573 2.64h-1.656v-8.172h-2.904V8.628h7.476v1.428h-2.916v8.172z"
        fill="#fff"
      />
      <path
        d="M20.049 17.812a5.5 5.5 0 01-5.5-5.5m5.5 5.5a5.5 5.5 0 005.5-5.5m-5.5 5.5v3.666m-5.5-9.166v-5.5c0-1.013.82-1.834 1.833-1.834h7.333c1.013 0 1.834.821 1.834 1.834v5.5m-11 0V8.645a1.833 1.833 0 10-3.667 0 3.667 3.667 0 003.667 3.667zm11 0V8.645a1.833 1.833 0 013.666 0 3.667 3.667 0 01-3.666 3.667zm-5.5 9.166h-2.75m2.75 0h2.75"
        stroke="#fff"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_137_577"
        x1={63.4774}
        y1={13.7098}
        x2={126.049}
        y2={13.7098}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AFB6BE" stopOpacity={0.3} />
        <stop offset={1} stopColor="#AFB6BE" />
      </linearGradient>
      <clipPath id="clip0_137_577">
        <path fill="#fff" transform="translate(.049 .228)" d="M0 0H126V27H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const Copy = () => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.618 4.973c0-.483.392-.875.875-.875H16a.876.876 0 110 1.751H6.37v10.507a.876.876 0 01-1.751 0V4.973z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.12 8.476c0-.484.392-.876.876-.876h10.507c.483 0 .875.392.875.876v10.507a2.627 2.627 0 01-2.626 2.627h-7.005a2.627 2.627 0 01-2.627-2.627V8.476zm1.751.876v9.631c0 .484.392.876.876.876h7.005a.876.876 0 00.875-.876V9.352H9.871z"
    />
  </svg>
);

export const Farcaster = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.334 4.587h11.627v2.347h3.307l-.694 2.347h-.586v9.493c.294 0 .533.24.533.534v.64h.107c.294 0 .533.238.533.533v.64h-5.973v-.64c0-.295.239-.533.533-.533h.107v-.64c0-.258.183-.474.427-.523v-5.238h-.017a4.107 4.107 0 00-8.18 0H8.04v5.227h.107c.294 0 .533.24.533.534v.64h.107c.294 0 .533.238.533.533v.64H3.348v-.64c0-.295.239-.533.533-.533h.107v-.64c0-.295.239-.534.533-.534V9.281h-.586L3.24 6.934h3.093V4.587z"
    />
  </svg>
);

export const Settings = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.975 2.854h2.849l1.531 2.302a.498.498 0 00.517.205l2.469-.576 2.117 2.118-.566 2.478c-.049.195.039.4.205.517l2.302 1.531v2.85l-2.302 1.53a.494.494 0 00-.205.518l.566 2.478-2.117 2.117-2.469-.576a.498.498 0 00-.517.205l-1.531 2.303h-2.85l-1.54-2.303a.49.49 0 00-.508-.205l-2.478.576-2.117-2.117.566-2.478a.479.479 0 00-.205-.517l-2.293-1.532V11.43l2.293-1.531a.479.479 0 00.205-.517L4.33 6.903l2.117-2.118 2.478.576a.49.49 0 00.507-.205l1.542-2.302zm1.044 1.951l-.956 1.434a2.455 2.455 0 01-2.576 1.025l-1.424-.332-.586.585.322 1.425a2.417 2.417 0 01-1.024 2.575l-1.425.956v.761l1.425.956a2.417 2.417 0 011.024 2.576l-.322 1.424.586.586 1.424-.332a2.455 2.455 0 012.576 1.024l.956 1.434h.76l.947-1.434a2.463 2.463 0 012.585-1.024l1.415.332.595-.586-.332-1.424a2.433 2.433 0 011.025-2.576l1.434-.956v-.76l-1.434-.957a2.432 2.432 0 01-1.025-2.575l.332-1.425-.595-.585-1.415.332a2.463 2.463 0 01-2.585-1.025l-.946-1.434h-.761zm.38 6.585c-.81 0-1.463.654-1.463 1.464 0 .81.653 1.463 1.463 1.463.8 0 1.464-.653 1.464-1.463s-.664-1.464-1.464-1.464zm-3.414 1.464a3.412 3.412 0 013.414-3.415 3.418 3.418 0 013.415 3.415 3.418 3.418 0 01-3.415 3.414 3.412 3.412 0 01-3.414-3.414z" />
  </svg>
);

export const Burger = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMinYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.65 7.854a1 1 0 011-1h15a1 1 0 110 2h-15a1 1 0 01-1-1zm0 5a1 1 0 011-1h15a1 1 0 110 2h-15a1 1 0 01-1-1zm1 4a1 1 0 100 2h15a1 1 0 000-2h-15z"
    />
  </svg>
);
